import { render } from "./CourseInstructor.vue?vue&type=template&id=fda4ae30&ts=true"
import script from "./CourseInstructor.vue?vue&type=script&lang=ts"
export * from "./CourseInstructor.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__